module.exports = __webpack_public_path__ + "static/media/vivekaFacebook-1200x630.4518da7f.jpg";